import React from "react"
import { StickyNote } from "lucide-react"
import "./NotesEmpty.style.scss"

interface NotesEmptyProps {
  onCreate: () => void
}

const NotesEmpty = ({ onCreate }: NotesEmptyProps) => (
  <div className="notes-empty">
    <StickyNote size={48} aria-hidden />
    <h3>No notes yet</h3>
    <p>
      Create your first note to keep track of important formulas, concepts, or
      reminders.
    </p>
    <button type="button" onClick={onCreate}>
      New Note
    </button>
  </div>
)

export default NotesEmpty
